import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../shared/store/portal/alertStore';
import { BlackFitBtn } from '../../shared/component/headless/button/BtnBody';
import { getBtnName } from '../../shared/constants/btnNames';
import { MediumIcon } from '../../shared/component/IconBody';
import logo from '../../asset/gnb/logo_fit.png';
import { paperTextureAlert } from '../../shared/component/paperTexture';


const AlertComp: React.FC = () => {
  const { queue, isClosing, isExecuting, executeCurrent } =
    useStandardAlertStore();
  const alertRef = useRef<HTMLDivElement>(null);

  const currentStandardAlert = queue[0];

  useEffect(() => {
    if (alertRef.current) {
      alertRef.current.focus();
    }
  }, []);

  if (queue.length === 0) return null;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      void executeCurrent();
      return;
    }
    if (event.target !== event.currentTarget) return;

    if (event.key !== 'Enter') return;
    event.preventDefault();
    void executeCurrent();
  };

  return (
    <AlertContent ref={alertRef} onKeyDown={handleKeyDown} tabIndex={-1}>
      <AlertHeader>
        <MediumIcon src={logo} alt='logo icon' />
      </AlertHeader>
      <Content>{currentStandardAlert.content}</Content>
      <ButtonContainer>
        <BlackFitBtn
          disabled={isClosing || isExecuting}
          onClick={() => void executeCurrent()}
        >
          {getBtnName('OK')}
        </BlackFitBtn>
      </ButtonContainer>
    </AlertContent>
  );
};


const AlertHeader = styled.div`
  margin-bottom: 12px;
  user-select: none;
`;

const Content = styled.div`
  margin-bottom: 44px;
  white-space: pre-line;
  line-height: 20px;
  ${({ theme }) => theme.typography.Body_03_2};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const AlertContent = styled.div`
  position: fixed;
  top: calc(10vh);
   /* 화면 가운데 정렬 */
  left: 50%;
  transform: translateX(-50%);
  min-width: 500px;
  min-height: 50px;
  width: fit-content;
  height: fit-content;
  outline: none;
  padding: 20px;

  ${paperTextureAlert}
  background-color: ${({ theme }) => theme.colors.color_White};
`;

export default AlertComp;
